<template>
    <Breadcrumb class='my' separator=" >> ">
        <Breadcrumb-item v-bind:key="itemIndex" v-for="(item, itemIndex) in BreadcrumbList">{{item}}</Breadcrumb-item>
    </Breadcrumb>
</template>

<script>
	export default {
		props: ['BreadcrumbList'],
		data() {
			return {
				
			};
		}
	}
</script>

<style>
	.my{
		text-align: left;
		line-height: -1%;
		border-bottom: 1px solid #55557f;
	}
</style>
